module.exports = __webpack_public_path__ + "static/media/error.ec5eb4cc.png";